import { BoardItem, BoardItemParams } from 'models/BoardItem';

export type BoardParams = Readonly<{
    items: BoardItemParams[]
    nextPage: number | null
    authorized: boolean
}>

export class Board implements BoardParams {
    readonly items: BoardItem[]
    readonly nextPage: number | null
    readonly authorized: boolean

    constructor(params: BoardParams) {
        this.items = params.items.map((value) => BoardItem.of(value))
        this.nextPage = params.nextPage
        this.authorized = params.authorized

        Object.freeze(this)
    }

    static init(items: BoardItemParams[], authorized: boolean): Board {
        return new Board({ items, authorized, nextPage: 2 })
    }

    get hasMore(): boolean {
        return this.nextPage !== null
    }

    get isEmpty(): boolean {
        return this.items.length === 0
    }

    append(items: BoardItemParams[]): Board {
        return this.copy({
            items: [...this.items, ...items],
            nextPage: items.length ? (this.nextPage ?? 0) + 1 : null
        })
    }

    private copy(params: Partial<BoardParams>): Board {
        return new Board({...this, ...params})
    }
}
